export const ORDER_SERVICEABLE_STATUS_SUPPORT_URL = "https://partner.titan.email/hc/en-us/articles/51386517926297-Servicable-Status";